// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2BHAJ","shift":"index-module--shift--14cgH","announcementsWrapper":"index-module--announcementsWrapper--2qOuX"};